import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { MorningMinutesReportPreviewPage } from './morning-minutes-report-preview';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { DirectivesModule } from '../../../directives/directives.module';

@NgModule({
  declarations: [
    MorningMinutesReportPreviewPage,
  ],
  imports: [
    DirectivesModule,
    IonicPageModule.forChild(MorningMinutesReportPreviewPage),
    PdfViewerModule,
  ],
})
export class MorningMinutesReportPreviewPageModule {
}



// WEBPACK FOOTER //
// ./src/pages/morning-minutes/morning-minutes-report-preview/morning-minutes-report-preview.module.ts